module.exports = __webpack_public_path__ + "img/delete.3b29ec03.svg";